import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _UserMenu_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './menu.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
let cached = esc(require('@glimmer/tracking')).cached;
import { getOwner } from "@ember/application";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { wantsNewWindow } from "discourse/lib/intercept-click";
import UserMenuTab, { CUSTOM_TABS_CLASSES } from "discourse/lib/user-menu/tab";
import { NO_REMINDER_ICON } from "discourse/models/bookmark";
import deprecated from "discourse-common/lib/deprecated";
import getUrl from "discourse-common/lib/get-url";
import { bind } from "discourse-common/utils/decorators";
import UserMenuBookmarksList from "./bookmarks-list";
import UserMenuLikesNotificationsList from "./likes-notifications-list";
import UserMenuMessagesList from "./messages-list";
import UserMenuNotificationsList from "./notifications-list";
import UserMenuOtherNotificationsList from "./other-notifications-list";
import UserMenuProfileTabContent from "./profile-tab-content";
import UserMenuRepliesNotificationsList from "./replies-notifications-list";
import UserMenuReviewablesList from "./reviewables-list";
import esc from "../../../../../../../../../node_modules/@embroider/macros/src/addon/es-compat2";
import TEMPLATE from "./menu.hbs";
import { setComponentTemplate } from "@ember/component";
const DEFAULT_TAB_ID = "all-notifications";
const DEFAULT_PANEL_COMPONENT = UserMenuNotificationsList;
const REVIEW_QUEUE_TAB_ID = "review-queue";
const CORE_TOP_TABS = [class extends UserMenuTab {
  constructor() {
    super(...arguments);
    _defineProperty(this, "id", DEFAULT_TAB_ID);
    _defineProperty(this, "icon", "bell");
    _defineProperty(this, "panelComponent", DEFAULT_PANEL_COMPONENT);
  }
  get linkWhenActive() {
    return `${this.currentUser.path}/notifications`;
  }
}, class extends UserMenuTab {
  constructor() {
    super(...arguments);
    _defineProperty(this, "id", "replies");
    _defineProperty(this, "icon", "user_menu.replies");
    _defineProperty(this, "panelComponent", UserMenuRepliesNotificationsList);
    _defineProperty(this, "notificationTypes", ["mentioned", "group_mentioned", "posted", "quoted", "replied"]);
  }
  get count() {
    return this.getUnreadCountForType("mentioned") + this.getUnreadCountForType("group_mentioned") + this.getUnreadCountForType("posted") + this.getUnreadCountForType("quoted") + this.getUnreadCountForType("replied");
  }
  get linkWhenActive() {
    return `${this.currentUser.path}/notifications/responses`;
  }
}, class extends UserMenuTab {
  constructor() {
    super(...arguments);
    _defineProperty(this, "id", "likes");
    _defineProperty(this, "icon", "heart");
    _defineProperty(this, "panelComponent", UserMenuLikesNotificationsList);
  }
  get shouldDisplay() {
    return !this.currentUser.user_option.likes_notifications_disabled;
  }
  get count() {
    return this.getUnreadCountForType("liked") + this.getUnreadCountForType("liked_consolidated") + this.getUnreadCountForType("reaction");
  }

  // TODO(osama): reaction is a type used by the reactions plugin, but it's
  // added here temporarily until we add a plugin API for extending
  // filterByTypes in lists
  get notificationTypes() {
    return ["liked", "liked_consolidated", "reaction"];
  }
  get linkWhenActive() {
    return `${this.currentUser.path}/notifications/likes-received`;
  }
}, class extends UserMenuTab {
  constructor() {
    super(...arguments);
    _defineProperty(this, "id", "messages");
    _defineProperty(this, "icon", "notification.private_message");
    _defineProperty(this, "panelComponent", UserMenuMessagesList);
    _defineProperty(this, "notificationTypes", ["private_message", "group_message_summary"]);
  }
  get count() {
    return this.getUnreadCountForType("private_message");
  }
  get shouldDisplay() {
    return this.currentUser?.can_send_private_messages;
  }
  get linkWhenActive() {
    return `${this.currentUser.path}/messages`;
  }
}, class extends UserMenuTab {
  constructor() {
    super(...arguments);
    _defineProperty(this, "id", "bookmarks");
    _defineProperty(this, "icon", NO_REMINDER_ICON);
    _defineProperty(this, "panelComponent", UserMenuBookmarksList);
    _defineProperty(this, "notificationTypes", ["bookmark_reminder"]);
  }
  get count() {
    return this.getUnreadCountForType("bookmark_reminder");
  }
  get linkWhenActive() {
    return `${this.currentUser.path}/activity/bookmarks`;
  }
}, class extends UserMenuTab {
  constructor() {
    super(...arguments);
    _defineProperty(this, "id", REVIEW_QUEUE_TAB_ID);
    _defineProperty(this, "icon", "flag");
    _defineProperty(this, "panelComponent", UserMenuReviewablesList);
    _defineProperty(this, "linkWhenActive", getUrl("/review"));
  }
  get shouldDisplay() {
    return this.currentUser.can_review && this.currentUser.get("reviewable_count");
  }
  get count() {
    return this.currentUser.get("reviewable_count");
  }
}];
const CORE_BOTTOM_TABS = [class extends UserMenuTab {
  constructor() {
    super(...arguments);
    _defineProperty(this, "id", "profile");
    _defineProperty(this, "icon", "user");
    _defineProperty(this, "panelComponent", UserMenuProfileTabContent);
  }
  get linkWhenActive() {
    return `${this.currentUser.path}/summary`;
  }
}];
const CORE_OTHER_NOTIFICATIONS_TAB = class CORE_OTHER_NOTIFICATIONS_TAB extends UserMenuTab {
  constructor(currentUser, siteSettings, site, otherNotificationTypes) {
    super(...arguments);
    _defineProperty(this, "id", "other-notifications");
    _defineProperty(this, "icon", "discourse-other-tab");
    _defineProperty(this, "panelComponent", UserMenuOtherNotificationsList);
    this.otherNotificationTypes = otherNotificationTypes;
  }
  get count() {
    return this.otherNotificationTypes.reduce((sum, notificationType) => {
      return sum + this.getUnreadCountForType(notificationType);
    }, 0);
  }
  get notificationTypes() {
    return this.otherNotificationTypes;
  }
};
function resolvePanelComponent(owner, panelComponent) {
  if (typeof panelComponent === "string") {
    const nameForConsole = JSON.stringify(panelComponent);
    deprecated(`user-menu tab panelComponent must be passed as a component class (passed ${nameForConsole})`, {
      id: "discourse.user-menu.panel-component-class"
    });
    return owner.resolveRegistration(`component:${panelComponent}`);
  }
  return panelComponent;
}
let UserMenu = (_class = (_UserMenu_brand = /*#__PURE__*/new WeakSet(), class UserMenu extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _UserMenu_brand);
    _initializerDefineProperty(this, "appEvents", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _initializerDefineProperty(this, "router", _descriptor3, this);
    _initializerDefineProperty(this, "site", _descriptor4, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor5, this);
    _initializerDefineProperty(this, "currentTabId", _descriptor6, this);
    _initializerDefineProperty(this, "currentPanelComponent", _descriptor7, this);
    _initializerDefineProperty(this, "currentNotificationTypes", _descriptor8, this);
    this.router.on("routeDidChange", this.onRouteChange);
  }
  willDestroy() {
    super.willDestroy(...arguments);
    this.router.off("routeDidChange", this.onRouteChange);
  }
  onRouteChange() {
    this.args.closeUserMenu();
  }
  get classNames() {
    let classes = ["user-menu", "revamped", "menu-panel", "drop-down"];
    if (this.siteSettings.show_user_menu_avatars) {
      classes.push("show-avatars");
    }
    return classes.join(" ");
  }
  get topTabs() {
    const tabs = [];
    CORE_TOP_TABS.forEach(tabClass => {
      const tab = new tabClass(this.currentUser, this.siteSettings, this.site);
      if (tab.shouldDisplay) {
        tabs.push(tab);
      }
    });
    let reviewQueueTabIndex = tabs.findIndex(tab => tab.id === REVIEW_QUEUE_TAB_ID);
    CUSTOM_TABS_CLASSES.forEach(tabClass => {
      const tab = new tabClass(this.currentUser, this.siteSettings, this.site);
      if (tab.shouldDisplay) {
        if (reviewQueueTabIndex === -1) {
          tabs.push(tab);
        } else {
          tabs.insertAt(reviewQueueTabIndex, tab);
          reviewQueueTabIndex++;
        }
      }
    });
    tabs.push(new CORE_OTHER_NOTIFICATIONS_TAB(this.currentUser, this.siteSettings, this.site, _assertClassBrand(_UserMenu_brand, this, _notificationTypesForTheOtherTab).call(this, tabs)));
    return tabs.map((tab, index) => {
      tab.position = index;
      return tab;
    });
  }
  get bottomTabs() {
    const tabs = [];
    CORE_BOTTOM_TABS.forEach(tabClass => {
      const tab = new tabClass(this.currentUser, this.siteSettings, this.site);
      if (tab.shouldDisplay) {
        tabs.push(tab);
      }
    });
    const topTabsLength = this.topTabs.length;
    return tabs.map((tab, index) => {
      tab.position = index + topTabsLength;
      return tab;
    });
  }
  handleTabClick(tab, event) {
    if (wantsNewWindow(event) || this.currentTabId === tab.id) {
      // Allow normal navigation to href
      return;
    }
    if (event.type === "keydown" && event.keyCode !== 13) {
      return;
    }
    event.preventDefault();
    this.currentTabId = tab.id;
    this.currentPanelComponent = resolvePanelComponent(getOwner(this), tab.panelComponent);
    this.appEvents.trigger("user-menu:tab-click", tab.id);
    this.currentNotificationTypes = tab.notificationTypes;
  }
  triggerRenderedAppEvent() {
    this.appEvents.trigger("user-menu:rendered");
  }
  focusFirstTab(topTabsContainerElement) {
    topTabsContainerElement.querySelector(".btn.active")?.focus();
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "currentTabId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return DEFAULT_TAB_ID;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentPanelComponent", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return DEFAULT_PANEL_COMPONENT;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "currentNotificationTypes", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onRouteChange", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "onRouteChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "topTabs", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "topTabs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bottomTabs", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "bottomTabs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTabClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTabClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triggerRenderedAppEvent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "triggerRenderedAppEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusFirstTab", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusFirstTab"), _class.prototype)), _class);
function _notificationTypesForTheOtherTab(tabs) {
  const usedNotificationTypes = tabs.filter(tab => tab.notificationTypes).map(tab => tab.notificationTypes).flat();
  return Object.keys(this.site.notification_types).filter(notificationType => !usedNotificationTypes.includes(notificationType));
}
export { UserMenu as default };
setComponentTemplate(TEMPLATE, UserMenu);